import { AppRoute } from "modules/routing/types/AppRoute";
import { OpportunitiesList } from "../pages/OpportunitiesList/OpportunitiesList";
import { ViewAmmendOpportunity } from "../pages/ViewAmmendOpportunity/ViewAmmendOpportunity";

export const opportunitiesManagementHome = '/opportunities';

export const viewAmmendOpportunityRoute = (id?: string): string => {
    return `/opportunity/${id ?? ':id'}`
}

export const opportunitiesManagementRoutes: AppRoute[] = [
    {
        name: 'Issues Management List Home',
        path: opportunitiesManagementHome,
        exact: true,
        component: OpportunitiesList
    },
    {
        name: 'View/Ammend Near Miss',
        path: viewAmmendOpportunityRoute(),
        exact: true,
        component: ViewAmmendOpportunity
    }
];